import React from 'react';

//import NormalImg from '../common/Img';
//import styled from 'styled-components';

import IconSDMT1 from '../../assets/img/sdmt/sdmt1.svg';
import IconSDMT2 from '../../assets/img/sdmt/sdmt2.svg';
import IconSDMT3 from '../../assets/img/sdmt/sdmt3.svg';
import IconSDMT4 from '../../assets/img/sdmt/sdmt4.svg';
import IconSDMT5 from '../../assets/img/sdmt/sdmt5.svg';
import IconSDMT6 from '../../assets/img/sdmt/sdmt6.svg';
import IconSDMT7 from '../../assets/img/sdmt/sdmt7.svg';
import IconSDMT8 from '../../assets/img/sdmt/sdmt8.svg';
import IconSDMT9 from '../../assets/img/sdmt/sdmt9.svg';

class SDMTTest extends React.Component {
    
    

    constructor() {
        super();
        this.state = {
        //history: [{
        buttons: [
{ id: 1, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 2, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 3, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 4, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 5, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 6, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 7, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 8, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 9, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 10, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 11, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 12, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 13, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 14, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 15, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 16, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 17, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 18, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 19, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 20, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 21, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 22, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 23, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 24, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 25, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 26, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 27, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 28, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 29, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 30, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 31, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 32, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 33, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 34, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 35, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 36, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 37, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 38, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 39, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 40, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 41, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 42, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 43, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 44, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 45, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 46, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 47, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 48, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 49, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 50, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 51, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 52, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 53, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 54, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 55, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 56, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 57, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 58, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 59, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 60, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 61, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 62, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 63, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 64, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 65, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 66, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 67, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 68, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 69, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 70, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 71, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 72, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 73, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 74, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 75, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 76, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 77, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 78, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 79, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 80, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 81, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 82, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 83, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 84, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 85, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 86, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 87, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 88, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 89, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 90, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 91, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 92, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 93, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 94, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 95, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 96, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 97, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 98, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 99, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 100, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 101, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 102, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 103, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 104, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 105, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 106, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 107, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 108, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 109, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 110, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 111, name: '2', icon: IconSDMT2, class:'btn-sdmt col-sm-1' },
{ id: 112, name: '1', icon: IconSDMT1, class:'btn-sdmt col-sm-1' },
{ id: 113, name: '6', icon: IconSDMT6, class:'btn-sdmt col-sm-1' },
{ id: 114, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },
{ id: 115, name: '7', icon: IconSDMT7, class:'btn-sdmt col-sm-1' },
{ id: 116, name: '3', icon: IconSDMT3, class:'btn-sdmt col-sm-1' },
{ id: 117, name: '5', icon: IconSDMT5, class:'btn-sdmt col-sm-1' },
{ id: 118, name: '4', icon: IconSDMT4, class:'btn-sdmt col-sm-1' },
{ id: 119, name: '8', icon: IconSDMT8, class:'btn-sdmt col-sm-1' },
{ id: 120, name: '9', icon: IconSDMT9, class:'btn-sdmt col-sm-1' },

        ],
        //}],
            xIsNext: true,
            stepNumber: 0,
            mode: "demo"
            //buttons: Array(9).fill(null)
            
        };

        
    }

    handleTouchEnd(i,buttons) {
        //const history = this.state.history;
        //const current = history[history.length - 1];
        //const buttons = current.buttons.slice();
        //if (calculateWinner(buttons) || buttons[i]) {
        //return;
        //}
       
        

        buttons[i].class = buttons[i].class === "btn-sdmt col-sm-1" ? "btn-sdmt-primary col-sm-1" : "btn-sdmt col-sm-1" ;

        

       this.setState({
        //history: history.concat([{
            //buttons: buttons
        //}]),
        //xIsNext: !this.state.xIsNext,
            //buttons[i]: { class:"btn-primary" }//this.state.xIsNext ? 'X' : 'O';
        });
    }
    
    render() {

        //console.log(this.props);

        return (
            <div className="sdmt-grid-container">
                <SDMTGrid
                    buttons={this.state.buttons}
                    onTouchEnd={(i) => this.handleTouchEnd(i,this.state.buttons)}
                    mode={this.props.mode}/>
            </div>
        );
    }
}

class SDMTGrid extends React.Component {
    constructor() {
        super();
        this.state = {
        //buttons: Array(9).fill(null),
        //xIsNext: true,
        };
    }
    
    renderButton(i) {
        return <SDMTButton 
            value={this.props.buttons[i].name} 
            class={this.props.buttons[i].class} 
            icon={this.props.buttons[i].icon} 
            onTouchEnd={() => this.props.onTouchEnd(i)}/>;
    }

    renderEmpty() {
        return <EmptyGridCell />
    }
    
    render() {
        
        const gridDemoNoIcons = (
            <div className="row">
                <div className="btn-sdmt-group no-icons">
                {this.renderButton(0)}
                {this.renderButton(1)}
                {this.renderButton(2)}
                {this.renderButton(3)}
                {this.renderButton(4)}
                {this.renderButton(5)}
                {this.renderButton(6)}
                {this.renderButton(7)}
                {this.renderButton(8)}
                {this.renderButton(9)}
                
                </div>
                </div>
        );

        const gridDemoIcons = (
             <div className="row">
                <div className="btn-sdmt-group">
                {this.renderButton(0)}
                {this.renderButton(1)}
                {this.renderButton(2)}
                {this.renderButton(3)}
                {this.renderButton(4)}
                {this.renderButton(5)}
                {this.renderButton(6)}
                {this.renderButton(7)}
                {this.renderButton(8)}
                {this.renderButton(9)}
                
                </div>
                </div>
        );

        const gridFull = (
            <div>
                <div className="row">
                <div className="btn-sdmt-group">
                {this.renderButton(10)}
                {this.renderButton(11)}
                {this.renderButton(12)}
                {this.renderButton(13)}
                {this.renderButton(14)}
                
                </div>
                </div>

                <div className="row">
                <div className="btn-sdmt-group">
                    
{this.renderButton(15)}
{this.renderButton(16)}
{this.renderButton(17)}
{this.renderButton(18)}
{this.renderButton(19)}
{this.renderButton(20)}
{this.renderButton(21)}
{this.renderButton(22)}
{this.renderButton(23)}
{this.renderButton(24)}
{this.renderButton(25)}
{this.renderButton(26)}
{this.renderButton(27)}
{this.renderButton(28)}
{this.renderButton(29)}

                </div>
                </div>

                <div className="row">
                <div className="btn-sdmt-group">
                    
{this.renderButton(30)}
{this.renderButton(31)}
{this.renderButton(32)}
{this.renderButton(33)}
{this.renderButton(34)}
{this.renderButton(35)}
{this.renderButton(36)}
{this.renderButton(37)}
{this.renderButton(38)}
{this.renderButton(39)}
{this.renderButton(40)}
{this.renderButton(41)}
{this.renderButton(42)}
{this.renderButton(43)}
{this.renderButton(44)}


                </div>
                </div>

                <div className="row">
                <div className="btn-sdmt-group">
{this.renderButton(45)}
{this.renderButton(46)}
{this.renderButton(47)}
{this.renderButton(48)}
{this.renderButton(49)}
{this.renderButton(50)}
{this.renderButton(51)}
{this.renderButton(52)}
{this.renderButton(53)}
{this.renderButton(54)}
{this.renderButton(55)}
{this.renderButton(56)}
{this.renderButton(57)}
{this.renderButton(58)}
{this.renderButton(59)}
                    
                </div>
                </div>    

                <div className="row">
                <div className="btn-sdmt-group">
{this.renderButton(60)}
{this.renderButton(61)}
{this.renderButton(62)}
{this.renderButton(63)}
{this.renderButton(64)}
{this.renderButton(65)}
{this.renderButton(66)}
{this.renderButton(67)}
{this.renderButton(68)}
{this.renderButton(69)}
{this.renderButton(70)}
{this.renderButton(71)}
{this.renderButton(72)}
{this.renderButton(73)}
{this.renderButton(74)}
                    
                </div>
                </div>    

                <div className="row">
                <div className="btn-sdmt-group">
{this.renderButton(75)}
{this.renderButton(76)}
{this.renderButton(77)}
{this.renderButton(78)}
{this.renderButton(79)}
{this.renderButton(80)}
{this.renderButton(81)}
{this.renderButton(82)}
{this.renderButton(83)}
{this.renderButton(84)}
{this.renderButton(85)}
{this.renderButton(86)}
{this.renderButton(87)}
{this.renderButton(88)}
{this.renderButton(89)}
                    
                </div>
                </div>    

                <div className="row">
                <div className="btn-sdmt-group">
{this.renderButton(90)}
{this.renderButton(91)}
{this.renderButton(92)}
{this.renderButton(93)}
{this.renderButton(94)}
{this.renderButton(95)}
{this.renderButton(96)}
{this.renderButton(97)}
{this.renderButton(98)}
{this.renderButton(99)}
{this.renderButton(100)}
{this.renderButton(101)}
{this.renderButton(102)}
{this.renderButton(103)}
{this.renderButton(104)}
                    
                </div>
                </div>    

               <div className="row"> 
                <div className="btn-sdmt-group">
{this.renderButton(105)}
{this.renderButton(106)}
{this.renderButton(107)}
{this.renderButton(108)}
{this.renderButton(109)}
{this.renderButton(110)}
{this.renderButton(111)}
{this.renderButton(112)}
{this.renderButton(113)}
{this.renderButton(114)}
{this.renderButton(115)}
{this.renderButton(116)}
{this.renderButton(117)}
{this.renderButton(118)}
{this.renderButton(119)}
                    
                </div>
                </div>    

            </div>
        );


        return (
            this.props.mode === "demo" ? gridDemoNoIcons : 
            this.props.mode === "practice" ? gridDemoIcons : gridFull
        );
    }
}

function SDMTButton(props) {
    //var buttonIcon = "/assets/img/sdmt/" +props.icon;
    var altTag = "SDMT Icon " + props.value;
    return (
        <div className={props.class} onTouchEnd={() => props.onTouchEnd()} unselectable="on">
         <img src={props.icon} alt={altTag} unselectable="on"/>  
        <div className="btn-value" unselectable="on">{props.value}</div>
        </div>
    );
}

function EmptyGridCell() {
    return (
    <div className="col-sm-1">
    </div>    
    );
}

document.ontouchmove = function(event){
    event.preventDefault();
}

export default SDMTTest;


// WEBPACK FOOTER //
// ./src/components/exam/SDMTTest.js